var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-514.000000, -382.000000)",
    fill: "rgba(222, 255, 255, 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.333273,382 C524.481533,382 524.624001,382.053387 524.735511,382.149085 L524.788569,382.200408 L527.252721,384.885309 C527.34308,384.983763 527.398988,385.108401 527.413117,385.240382 L527.416667,385.306897 L527.416667,392.809412 C527.416667,393.131461 526.592246,393.396345 526.27999,393.428197 L526.797426,393.431408 L523.049388,393.431254 L523.04986,395.378004 C523.04986,395.700053 522.806189,395.964936 522.493933,395.996789 L522.430619,396 L515.202574,396 C514.881952,396 514.618242,395.755245 514.58653,395.441599 L514.583333,395.378004 L514.583333,385.306897 C514.583333,384.984848 514.827004,384.719965 515.13926,384.688112 L515.202574,384.684901 L518.19712,384.684432 L518.197356,382.621996 C518.197356,382.299947 518.441027,382.035064 518.753283,382.003211 L518.816597,382 L524.333273,382 Z M518.19712,385.928425 L515.821476,385.928844 L515.821476,394.755489 L521.811083,394.755489 L521.810907,393.431254 L518.816597,393.431408 C518.495974,393.431408 518.232264,393.186653 518.200553,392.873008 L518.197356,392.809412 L518.19712,385.928425 Z M522.395149,383.24353 L519.435778,383.243894 L519.435778,392.187163 L526.177974,392.187163 L526.177624,386.789001 L523.078092,386.789345 C522.767652,386.789345 522.510144,386.557124 522.470695,386.254608 L522.46564,386.188766 L522.395149,383.24353 Z M524.061719,383.243894 L523.620408,383.24353 L523.675783,385.558193 L526.177624,385.558291 L526.177974,385.549426 L524.061719,383.243894 Z",
    id: "Shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cbfe36509c3bb82863999c71f9f1a68d.svg";
export { ForwardRef as ReactComponent };